import factsheetReducer from '../reducers/factsheet'
import { detectNewConflicts } from '../../components/Shared/Factsheet/contradictions/detector'
import { contradictionRules } from '../../components/Shared/Factsheet/contradictions/rules'
import { factConflictActions } from '../actions/factConflict'

// Set-time fact-conflict detection. Watches the two "set" factsheet actions and,
// when a user set would newly contradict another fact on the sheet, it holds the
// action back and raises the pending conflict that drives the fact-conflict modal.
// Nothing is applied until the user confirms ("Add anyway" replays the held
// action), so cancelling is a pure no-op — there is nothing to undo.
//
// It only reads the live redux facts slice, simulates the set with the pure
// factsheet reducer, and dispatches the modal action — the save-driven
// contradiction notification is a separate concern and is left untouched here.
const SET_ACTIONS = ['FACTSHEET_ADD_FACT_INSTANCE', 'FACTSHEET_PUT_ATTRIBUTE']

const factsheetContradiction = (store) => (next) => (action) => {
  if (!action || !SET_ACTIONS.includes(action.type)) {
    return next(action)
  }
  // programmatic/lifecycle sets (and the confirmed replay) opt out of the check
  // and always apply immediately.
  if (action.meta?.skipContradictionCheck) {
    return next(action)
  }

  const state = store.getState()
  const prevFacts = state.factsheet.facts
  // simulate the set without committing it, so we can decide before applying.
  const nextFacts = factsheetReducer(state.factsheet, action).facts

  const { payload } = action
  const conflict = detectNewConflicts(
    prevFacts,
    nextFacts,
    payload.factDefId,
    payload.attributeDefId,
    contradictionRules,
  )

  if (conflict) {
    // hold the set back and let the modal decide whether to replay it.
    store.dispatch(factConflictActions.showFactConflict({
      pairs: conflict.pairs,
      pendingAction: action,
    }))
    return undefined
  }

  return next(action)
}

export default factsheetContradiction
